import { HttpErrorResponse } from '@angular/common/http';
import { ErrorResponse } from './responses/error-response';

export class CustomError {
  public code!: number;
  public title!: string;
  public message!: string;

  constructor(err?: HttpErrorResponse | Error, serviceName?: string) {
    if (err instanceof HttpErrorResponse && err?.error) {
      const thrownError = err?.error as ErrorResponse;
      this.code = thrownError?.StatusCode;
      this.title = serviceName + ' ' + this.code?.toString(10);
      this.message = thrownError.Error;
    } else if (err instanceof Error) {
      this.title = serviceName ?? $localize`Error`;
      this.message = err.message || $localize`An unexpected error occurred.`;
    } else if (err) {
      this.title = serviceName ?? $localize`Error`;
      this.message = $localize`An unexpected error occurred.`;
    }
  }
}
